import { memo, FC } from 'react';
import styles from './index.module.scss';
import { ThemeRoutePlaceInfo } from '@/store/types';
import TimeSpot from './TimeSpot';
import CustomScroll from '@/pages/CharaterTimeLine/components/CustomScroll';

interface Props {
  list: ThemeRoutePlaceInfo[];
}

const RouteTimeLine: FC<Props> = ({ list }) => {

  return (
    <div className={styles.routeTimeLine}>
      <div className={styles.leftMask} />
      <div className={styles.rightMask} />
      {
        list?.length ?
          <div className={styles.content}>
            <CustomScroll>
              {
                list.map((item, index) => (
                  <TimeSpot index={index} key={index} item={item} length={list.length} />
                ))
              }
            </CustomScroll>
          </div> : null
      }
    </div>
  )
}


export default memo(RouteTimeLine);
